






































import { defineComponent, PropType } from '@vue/composition-api'
import { MainProduct } from '@/views/catalog/CatalogProductsList.vue'
import { BImg } from 'bootstrap-vue'

export default defineComponent({
  name: 'ProductRow',
  components: { BImg },
  props: {
    product: {
      type: Object as PropType<MainProduct>,
      required: true,
    },
  },
  computed: {
    calculateHeight(): string {
      return '100%'
      const heightInPixels = Math.ceil((window.innerHeight - 200) / 8)
      return `${heightInPixels}px`
    },
    calculateMaxWidth(): string {
      console.log(window.innerWidth)
      const widthInPixels = Math.ceil((window.innerWidth) / 6)
      return `${widthInPixels}px`
    },
  },
  methods: {
    goToProductDetails(productId: string) {
      this.$router.push({ name: 'catalogInstanceProductDetails', params: { productId, catalogId: this.$route.params.catalogId } })
    },
  },
})
